import { render, staticRenderFns } from "./PropertyField.vue?vue&type=template&id=37f62d03&scoped=true"
import script from "./PropertyField.vue?vue&type=script&lang=ts"
export * from "./PropertyField.vue?vue&type=script&lang=ts"
import style0 from "./PropertyField.vue?vue&type=style&index=0&id=37f62d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f62d03",
  null
  
)

export default component.exports